import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'translation-setting',
    components: {

    },
})

export default class TranslationSetting extends Vue {

    // ------------------------------------------------------------------
    // Properties
    @Prop()
    private selectedConfig: any;

    private defaultCheck: any = false;

    private defaultText: any = '';

    // -------------------------------------------------------------------
    // Hooks
    private created() {
        const tenantSettings = this.selectedConfig.tenantConfig;
        if (tenantSettings && tenantSettings.value) {
            this.defaultText = tenantSettings.value;
        }
    }

    // ------------------------------------------------------------------
    // Actions

    private onChangeConfig() {
        const defaultText =  {default_translation_label : this.defaultCheck};
        this.$emit('onChangeConfig', defaultText);
    }
}
